module.exports = __webpack_public_path__ + "img/aaw-logo.d6efe921.png";